var render = function render(){var _vm=this,_c=_vm._self._c;return _c('img',{attrs:{"src":require("../assets/img/user.png"),"alt":""}})
}
var staticRenderFns = []

export { render, staticRenderFns }